interface ISummaryItemsProps {
    isSignedOff: boolean;
    isEditMode: boolean;
    title: string;
    dataCy: string;
    content: JSX.Element;
    addItem: () => void;
}

function SummaryItems(props: ISummaryItemsProps): JSX.Element {
    return (!props.isSignedOff || props.isEditMode || props.content) ? (
        <tr>
            <td className="c1">
                <strong>{props.title}</strong>
            </td>
            <td className="c2">
                <div className="tb-row tb" data-cy={`medicalNote-${props.dataCy}`}>
                    <div className="add-btn-column-summary" style={{ verticalAlign: "top" }}>
                        {(props.isSignedOff || !props.isEditMode) ? "" : <a data-cy={`medicalNote-add-${props.dataCy}`} onClick={() => props.addItem()}>[+]</a>}
                    </div>
                    {props.content}
                </div>
            </td>
        </tr>
    )
        : null;
}

export { SummaryItems };
